import React from "react";
import WhatsAppWidget from "react-whatsapp-chat-widget";
import "react-whatsapp-chat-widget/index.css";
import logo from "../assets/a.jpg";

const WhatsApp = () => {
	return (
		<WhatsAppWidget
			phoneNo="+250780458297"
			position="right"
			widgetWidth="400px"
			widgetWidthMobile="260px"
			autoOpen={true}
			autoOpenTimer={5000}
			messageBox={true}
			messageBoxTxt="Hello, how can we help you?"
			iconSize="40"
			iconColor="white"
			iconBgColor="tomato"
			headerIcon={logo}
			headerIconColor="pink"
			headerTxtColor="black"
			headerBgColor="white"
			headerTitle="Customer Service"
			headerCaption="Online"
			bodyBgColor="#bbb"
			chatPersonName="Support"
			chatMessage={<>Hi there 👋 <br /><br /> How can I help you?</>}
			footerBgColor="#999"
			btnBgColor="yellow"
			btnTxtColor="black"
			btnTxt="Start Chat"
		/>
	);
};

export default WhatsApp;